export default __webpack_public_path__ + "static/media/7193_v1_500.6403c156.jpg";